<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>
<div class="container">
    <div class="content-top-box">
        <app-bread-crumb></app-bread-crumb>
    </div>
    <header>
        <h2>{{langObj ? langObj?.OperatorExecutionWindow : ('OperatorExecutionWindow' | translate)}}</h2>
    </header>
    <form name="operatorForm" [formGroup]="operatorForm" #formDirective="ngForm" (ngSubmit)="onSubmit(formDirective)">
        <div *ngIf="techEntryValues" class="mb-3">
            <h4>{{langObj ? langObj?.TechnicianEntry : ('TechnicianEntry' | translate)}}</h4>
            <div class="row">
                <mat-form-field appearence="fill">
                    <input formControlName="StartTime" [(ngModel)]="techEntryValues.StartTime" readonly matInput
                        placeholder="Start Time">
                </mat-form-field>
                <mat-form-field appearence="fill">
                    <input formControlName="CompleteTime" [(ngModel)]="techEntryValues.CompleteTime" readonly matInput
                        placeholder="Completed Time">
                </mat-form-field>
                <mat-form-field appearence="fill" class="remarks">
                    <mat-label>{{langObj ? langObj?.TechnicianRemarks : ('TechnicianRemarks' | translate)}}</mat-label>
                    <textarea matInput [(ngModel)]="techEntryValues.Remarks" formControlName="TechRemark"
                        readonly></textarea>
                </mat-form-field>
            </div>
            <h4 *ngIf="techEntryValues.AfterPicture">{{langObj ? langObj?.TechnicianImages : ('TechnicianImages' | translate)}}</h4>
            <div *ngIf="techEntryValues.AfterPicture" class="imgflex m-0">
                <div *ngFor="let img of techEntryValues.AfterPicture.split(','); let i = index" class="relative">
                    <div>
                        <img [src]="blobStorageUrl+img" alt="" width="250px" height="200px" (click)="imgview1()">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <mat-form-field appearence="fill" class="date">
                <input required formControlName="TimeStamp" [(ngModel)]="operator.TimeStamp" readonly matInput
                    [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [disabled]="isView || disable" [max]="maxSelectableDateTime$ | async">
                <mat-datepicker-toggle matSuffix [for]="$any(picker)"> </mat-datepicker-toggle>
                <ngx-mat-datetime-picker #picker [max]="maxSelectableDateTime$ | async" > </ngx-mat-datetime-picker>
                <mat-error>{{langObj ? langObj?.Dateisrequired : ('Dateisrequired' | translate)}}</mat-error>
            </mat-form-field>
            
            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.Line : ('Line' | translate)}}</mat-label>
                <mat-select required formControlName="line" [(ngModel)]="operator.line" name="Line" [disabled]="isView || disableHierarchyFields"
                    (selectionChange)="setNewUnitList('change')">
                    <mat-select-filter [placeholder]="'Search Line'" [displayMember]="'PL_Desc'" [array]="LineList"
                        (filteredReturn)="LineFilterList = $event">
                    </mat-select-filter>
                    <mat-option *ngFor="let line of LineFilterList" [value]="line.PL_Id">
                        {{ line.PL_Desc }}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.Lineisrequired : ('Lineisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <!-- <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.Unit : ('Unit' | translate)}}</mat-label>
                <mat-select required formControlName="unit" [(ngModel)]="operator.units" name="Unit" [disabled]="isView"
                    (selectionChange)="setAssemblyList('change')">
                    <mat-select-filter [placeholder]="'Search Unit'" [displayMember]="'PU_Desc'" [array]="UnitList"
                        (filteredReturn)="UnitFilterList = $event">
                    </mat-select-filter>
                    <mat-option *ngFor="let unit of UnitFilterList" [value]="unit.PU_Id">
                        {{ unit.PU_Desc }}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.Unitisrequired : ('Unitisrequired' | translate)}}</mat-error>
            </mat-form-field> -->

            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.Unit : ('Unit' | translate)}}</mat-label>
                <mat-select required formControlName="unit" [(ngModel)]="operator.units" name="Unit" [disabled]="isView || disableHierarchyFields"
                    (selectionChange)="setAssemblyList('change')">
                    <mat-select-filter [placeholder]="'Search Unit'" [displayMember]="'PU_Desc'" [array]="NewUnitList"
                        (filteredReturn)="NewUnitFilterList = $event">
                    </mat-select-filter>
                    <mat-option *ngFor="let unit of NewUnitFilterList" [value]="unit.PU_Id">
                        {{ unit.PU_Desc }}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.Unitisrequired : ('Unitisrequired' | translate)}}</mat-error>
            </mat-form-field>

            <mat-form-field appearence="fill" class="col" style="margin: 0;">
                <mat-label>{{langObj ? langObj?.Assembly : ('   Assembly' | translate)}}</mat-label>
                <mat-select required formControlName="assembly" [(ngModel)]="operator.assembly" name="Assembly"
                    [disabled]="isView || disableHierarchyFields" (selectionChange)="setSubAssemblyList('change')">
                    <mat-select-filter [placeholder]="'Search Assembly'" [displayMember]="'Assbly_Desc'"
                        [array]="AssemblyList" (filteredReturn)="AssemblyFilterList = $event">
                    </mat-select-filter>
                    <mat-option *ngFor="let assembly of AssemblyFilterList" [value]="assembly.Assbly_Id">
                        {{ assembly.Assbly_Desc }}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.Assemblyisrequired : ('Assemblyisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="isEdit" appearence="fill" class="col"  style="margin: 0 0 0 2%;">
                <mat-label>{{langObj?.MaintenanceScrap || ('MaintenanceScrap' | translate)}}</mat-label>
                <input matInput type="text" [value]="operator.MaintenanceScrap" readonly />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.SubAssembly : ('SubAssembly' | translate)}}</mat-label>
                <mat-select required formControlName="subAssembly" [(ngModel)]="operator.subAssembly" name="Sub Assembly"
                    [disabled]="isView || disableHierarchyFields" (selectionChange)="setComponentList('change')">
                    <mat-select-filter [placeholder]="'Search Sub Assembly'" [displayMember]="'SAsbly_Desc'"
                        [array]="SubAssemblyList" (filteredReturn)="SubAssemblyFilterList = $event">
                    </mat-select-filter>
                    <mat-option *ngFor="let subAssembly of SubAssemblyFilterList" [value]="subAssembly.SAssbly_Id">
                        {{ subAssembly.SAsbly_Desc }}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.SubAssemblyisrequired : ('SubAssemblyisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.Component : ('Component' | translate)}}</mat-label>
                <mat-select required formControlName="component" [(ngModel)]="operator.component" name="Component"
                    [disabled]="isView || disableHierarchyFields">
                    <mat-select-filter [placeholder]="'Search Component'" [displayMember]="'ComponentName'"
                        [array]="ComponentList" (filteredReturn)="ComponentFilterList = $event">
                    </mat-select-filter>
                    <mat-option *ngFor="let component of ComponentFilterList" [value]="component.ComponentId">
                        {{ component.ComponentName }}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.Componentisrequired : ('Componentisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.WOStatus : ('WOStatus' | translate)}}</mat-label>
                <mat-select required [(ngModel)]="operator.WOStatus" formControlName="status"
                    [disabled]="!techEntryValues || !techEntryValues?.CompleteTime || isView ? true : false">
                    <mat-option *ngFor="let status of filteredWoStatus" [value]="status.id">
                        {{status.title}}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.WOStatusisrequired : ('WOStatusisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.WOType : ('WOType' | translate)}}</mat-label>
                <mat-select required [(ngModel)]="operator.WOType" formControlName="woType"
                    (selectionChange)="getOperatorMasterData('change')" [disabled]="techEntryValues || isView ? true : false">
                    <input (keyup)="searchValues($event, 'woType')" class="form-control" placeholder="Search WO Type">
                    <mat-option *ngFor="let type of filteredWoType" [value]="type.ID">
                        {{type.Name}}
                    </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.WOTypeisrequired : ('WOTypeisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.FailureMode : ('FailureMode' | translate)}}</mat-label>
                <mat-select required [(ngModel)]="operator.FailureMode" formControlName="failMode"
                    [disabled]="techEntryValues || isView ? true : false">
                    <input (keyup)="searchValues($event, 'failMode')" class="form-control" placeholder="Search Mode">
                    <mat-option *ngFor="let mode of filteredFailMode" [value]="mode.ID"> {{mode.Name}} </mat-option>
                </mat-select>
                <mat-error>{{langObj ? langObj?.FailureModeisrequired : ('FailureModeisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <div class="toggle">
                <label>{{langObj ? langObj?.SpareParts : ('SpareParts' | translate)}}</label>
                <mat-slide-toggle [(ngModel)]="operator.SpareParts" formControlName="spare" [disabled]="isView">
                </mat-slide-toggle>
            </div>
        </div>
        <div class="row">
            <div class="machineBreakdownToggle">
                <label>{{langObj ? langObj?.MachineBreakdown : ('MachineBreakdown' | translate)}}</label>
                <mat-slide-toggle [(ngModel)]="operator.MachineBreakdown" formControlName="machineBreakdown" [disabled]="isView">
                </mat-slide-toggle>
            </div>

            <!-- <div class="toggle">
                <label>{{langObj ? langObj?.WorkPermit : ('WorkPermit' | translate)}}</label>
                <mat-slide-toggle [(ngModel)]="operator.WorkPermit" formControlName="workPermit" [hidden]="isView">
                </mat-slide-toggle>
            </div> -->

            <mat-form-field appearence="fill" class="col">
                <mat-label>{{langObj ? langObj?.ClosedAt : ('ClosedAt' | translate)}}</mat-label>
                <input matInput type="text"  [(ngModel)]="operator.ClosedAt" formControlName="ClosedAt"
                readonly>
            </mat-form-field>
            <mat-form-field appearence="fill" class="remarks">
                <mat-label>{{langObj ? langObj?.WorkOrderDetails : ('WorkOrderDetails' | translate)}}</mat-label>
                <textarea required matInput [(ngModel)]="operator.Remark" formControlName="remark"
                    [readonly]="isView" maxlength="500"></textarea>
                <div class="hint-wrapper">
                    <span class="max-char-hint">Max 500 characters</span>
                    <mat-hint align="end" style="margin-left: 25px;">{{ operator.Remark?.length || 0 }}/500</mat-hint>
                </div>
                <mat-error>{{langObj ? langObj?.WorkOrderDetailsisrequired : ('WorkOrderDetailsisrequired' | translate)}}</mat-error>
            </mat-form-field>
            <button mat-flat-button color="accent" [disabled]="isView" *ngIf="(isWrite | permissionChecker) || isView ? true : false" type="button"
                class="upload" (click)="openFile()">
                {{langObj ? langObj?.UploadPicture : ('UploadPicture' | translate)}}
            </button>
            <input type="file" (change)="readFile($event)" class="d-none" #fileInput accept="image/*" multiple>
        </div>

        <div *ngIf="FileData && FileData.length" class="imgflex">
            <div *ngFor="let file of FileData; let i = index" class="relative">
                <div>
                    <img *ngIf="file.FileType == 'image'" [src]="file.ImageSrc" alt="" width="250px" height="200px">
                </div>

                <img src="assets/images/remove.png" (click)="removeFile(i)" class="absolute" alt="" width="20px"
                    height="20px">

            </div>
        </div>

        <div *ngIf="EditFileData && EditFileData.length" class="imgflex">
            <div *ngFor="let file of EditFileData; let i = index" class="relative">
                <div>
                    <img [src]="blobStorageUrl+file.ImageSrc" alt="" width="250px" height="200px" (click)="imgview()">
                </div>

                <img *ngIf="!isView" src="assets/images/delete.png" (click)="deleteFile(i)" class="absolute" alt="" width="20px"
                    height="20px" >

            </div>
        </div>

        <div>
            <button class="submit" *ngIf="!isView && isUpdate | permissionChecker" type="submit">{{langObj ? langObj?.Submit : ('Submit'
                | translate)}}</button>
            <button class="cancel" routerLink="/PM/OperatorExecutionWindow"  type="button">Cancel</button>
        </div>
    </form>

    <!-- img popup -->
  <ng-template #operationimageViewModal>
    <button mat-mini-fab color="warn" (click)="oncloseimg()"><mat-icon>close</mat-icon></button>
    <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true" [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true"
      [useMouseWheel]="true" orientation="ltr">
      <mat-carousel-slide #matCarouselSlide *ngFor="let file of EditFileData; let i = index"  [image]="blobStorageUrl+file.ImageSrc"
        overlayColor="#00000040" [hideOverlay]="false"></mat-carousel-slide>
    </mat-carousel>
  </ng-template>
  <ng-template #technicianimageViewModal>
    <button mat-mini-fab color="warn" (click)="oncloseimg1()"><mat-icon>close</mat-icon></button>
    <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true" [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true"
      [useMouseWheel]="true" orientation="ltr">
      <mat-carousel-slide #matCarouselSlide *ngFor="let img of techEntryValues.AfterPicture.split(','); let i = index" [image]="blobStorageUrl+img"
        overlayColor="#00000040" [hideOverlay]="false"></mat-carousel-slide>
    </mat-carousel>
  </ng-template>
  <!-- end img popup -->

</div>